import React, { useEffect, useState } from "react";
import StatusComp from "../../../components/StatusComp";
import { Table } from "../../../components/Table/Table";
import { get } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";

const GroupAlertTypes = () => {
  const userData = JSON.parse(localStorage.getItem("user_details"));

  const [groupAlertTypesList, setGrupAlertTypesList] = useState([]);

  const getList = () => {
    get(URL.GROUP_USERS + userData?.knf_company_site_id)
      .then((res) => {
        if (res?.data?.alert_types?.length > 0) {
          setGrupAlertTypesList(res?.data?.alert_types);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  const columns = React.useMemo(() => [
    {
      Header: "S.No",
      accessor: "sno",
      Cell: ({ value, row }) => {
        return <p>{row.index + 1}</p>;
      },
    },
    {
      Header: "Name",
      accessor: "alert_name",
      Cell: ({ value, row }) => {
        return <p>{value}</p>;
      },
    },
    {
      Header: "Severity",
      accessor: "alert_severity",
      Cell: ({ value, row }) => {
        return <p className="text-center">{value}</p>;
      },
    },
  ]);

  return (
    <div className="dashRightView">
      <StatusComp name={"Alert Types"} hide={true} />

      <Table columns={columns} data={groupAlertTypesList} />
    </div>
  );
};

export default GroupAlertTypes;
